//@ts-ignore webpack 5 require without *
import tinycolor from 'tinycolor2';
import { CarModels } from './types';
export const isTooDarkVehicleColor = (theme, color) => {
    const default_color = theme.palette.mode == 'light' ? '#fff' : '#202020';
    const vehicle_color = color ?? default_color;
    const brightness = tinycolor(vehicle_color).getBrightness();
    const isTooDark = brightness < 40;
    return isTooDark;
};
export const getPointVehiclePosition = (value, is_mirrored = false) => {
    if (typeof value === 'number' && value > 5) {
        return is_mirrored ? 100 - value : value;
    }
    return value;
};
export const getVehicleThermometerPosition = (model) => {
    switch (model) {
        case CarModels.car:
            return {
                cabin: { left: 45, top: 50 },
                engine: { left: 77, top: 50 },
                outside: { left: 50, top: 5 },
                none: { left: 50, top: 50 },
            };
        case CarModels.hatch:
            return {
                cabin: { left: 45, top: 50 },
                engine: { left: 77, top: 50 },
                outside: { left: 50, top: 5 },
                none: { left: 50, top: 50 },
            };
        case CarModels.suv:
            return {
                cabin: { left: 45, top: 50 },
                engine: { left: 80, top: 50 },
                outside: { left: 50, top: 5 },
                none: { left: 50, top: 50 },
            };
        case CarModels.coupe:
            return {
                cabin: { left: 45, top: 50 },
                engine: { left: 70, top: 50 },
                outside: { left: 50, top: 5 },
                none: { left: 50, top: 50 },
            };
        case CarModels.porsche:
            return {
                cabin: { left: 45, top: 50 },
                engine: { left: 75, top: 50 },
                outside: { left: 50, top: 5 },
                none: { left: 50, top: 50 },
            };
        case CarModels.pickup:
            return {
                cabin: { left: 50, top: 50 },
                engine: { left: 85, top: 50 },
                outside: { left: 50, top: 5 },
                none: { left: 50, top: 50 },
            };
        case CarModels.boxVan:
            return {
                cabin: { left: 66, top: 50 },
                engine: { left: 86, top: 50 },
                outside: { left: 50, top: 5 },
                none: { left: 50, top: 50 },
            };
        case CarModels.wagon:
            return {
                cabin: { left: 35, top: 50 },
                engine: { left: 78, top: 50 },
                outside: { left: 50, top: 5 },
                none: { left: 50, top: 50 },
            };
        case CarModels.microbus:
            return {
                cabin: { left: 50, top: 50 },
                engine: { left: 85, top: 50 },
                outside: { left: 50, top: 5 },
                none: { left: 50, top: 50 },
            };
        case CarModels.gelik:
            return {
                cabin: { left: 35, top: 48 },
                engine: { left: 75, top: 48 },
                outside: { left: 50, top: 5 },
                none: { left: 50, top: 50 },
            };
        case CarModels.prado:
            return {
                cabin: { left: 35, top: 48 },
                engine: { left: 75, top: 48 },
                outside: { left: 50, top: 5 },
                none: { left: 50, top: 50 },
            };
        default:
            return {
                cabin: { left: 'none', top: 'none' },
                engine: { left: 'none', top: 'none' },
                outside: { left: 'none', top: 'none' },
                none: { left: 'none', top: 'none' },
            };
    }
};
